import { theme } from '@features/lci-report/domain/theme';
import { TextPropsTextConfig } from '@features/powerpoint';

// unicode character ↳ used as substitute for indent which cannot be done easily in pptxgenjs
const INDENT_CHARACTER = '\u21B3';

export const definitionText = (
  label: string,
  definition: string,
  options?: { subItem?: boolean }
): TextPropsTextConfig[] => {
  const { subItem } = options ?? { subItem: false };

  return [
    {
      text: subItem ? `${INDENT_CHARACTER} ${label}` : label,
      options: {
        color: theme.colors.inmarketGreen,
        breakLine: true,
      },
    },
    {
      text: definition,
      options: { breakLine: true, margin: [1, 1, 0, 0] },
    },
  ];
};
